<template>
  <div id="page-out-found" class="page-not-found">
    <cx-img 
      tag='i'
      class="m-graphic--404 cx-div"
      imgSrc="/static/graphic/mgto_graphic_404.png"
    ></cx-img>
    <h1 class="cx-t20" style="margin-top: 2.5rem;">
      <template v-if="pageLangSuggestions !== undefined">
        {{pageLangSuggestions ? ($t('pageNotFound.noLangForThisPage') || 'pageNotFound.noLangForThisPage') : $t('pageNotFound.pageNotFound')}}
      </template>
      <template v-else>
        {{$t('pageNotFound.pageNotFound')}}
      </template>
    </h1>
    <template v-if="pageLangSuggestions">
      <p>{{ $t('pageNotFound.backToPreviousLang') || 'pageNotFound.backToPreviousLang' }}</p>
      <ul class="lang-list" style="margin-top: 2rem">
        <li v-for="locale in pageLangSuggestions" :key="locale">
          <a
            class="cx-btn cx-btn--sub"
            :href="`/${locale}/${pureURL}`"
            target="_self"
          >
            {{availableLocaleNameMaps[locale] || locale}}
          </a>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import headerUpdater from '@/mixins/headerUpdater'
import supportLocale from '../../server/constants/supportLocale';

export default {
  name: 'page-not-found-view',
  mixins: [ headerUpdater({ firePageLoadedEvent: true }) ],
  header() {
    return {
      title: this.$t('pageNotFound.header')
    }
  },
  uit() {
    return [
      ['pageNotFound', ['header', 'pageNotFound', 'noLangForThisPage', 'backToPreviousLang']]
    ]
  },
  data() {
    return {
      options: [
        ...supportLocale
      ],
      pageLangSuggestions: undefined,
    }
  },
  computed: {
    pureURL: function() {
      let url = this.localedURL(this.$route.fullPath).replace('/', '').split('/');
      url.shift();
      return url.join('/');
    },
    availableLocaleNameMaps: function() {
      const availableLocaleNameMaps = {};
      this.options.forEach(opt => availableLocaleNameMaps[opt.locale] = opt.name)
      return availableLocaleNameMaps;
    },
  },
  mounted() {
    this.markPageLangMap404(this.$i18n.locale);
  },
  methods: {
    markPageLangMap404(lang) {
      if (typeof window === 'undefined') {
        return;
      }
      let pageLangMap = JSON.parse(sessionStorage.getItem('pageLangMap') || '{}');
      if (pageLangMap.path === this.pureURL) {
        pageLangMap[lang] = 404;
        const pageLangSuggestions = Object.entries(pageLangMap).filter(([key, value]) => value === 200).map(([lang]) => lang);
        this.pageLangSuggestions = pageLangSuggestions.length > 0 ? pageLangSuggestions : null;
        if (this.pageLangSuggestions) {
          document.title = this.$t('pageNotFound.noLangForThisPage') || 'pageNotFound.noLangForThisPage';
        }
      }
      sessionStorage.setItem('pageLangMap', JSON.stringify(pageLangMap));
    },
  },
}
</script>

<style lang="scss" scoped>
.lang-list {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  li {
    padding: 0.5rem;
  }
  @media (min-width: $breakpoint-sm){
    flex-direction: row;
  }
}
</style>

<style lang="scss">
.page-not-found{
  text-align: center;
  padding: 15vh $space-base;
  word-break: break-all;
  max-width: 1000px;
  margin: auto;
  .cx-t20{
    word-break: normal !important;
  }
}
</style>
